import {
  GET_CUSTOMERS,
  CUSTOMER_RESPONSE_HANDLER,
  GET_CUSTOMER,
  FAILED_HANDLER,
  GET_VOUCHERS,
  GET_CREDITS,
  VOUCHER_RESPONSE_HANDLER,
} from "../actions/types";

export default (state = {}, action) => {
  let status = 200;
  let data = {};
  let notificationType = "info";
  if (
    action.payload != undefined &&
    typeof action.payload.status != "undefined"
  ) {
    status = action.payload.status;
    notificationType = "success";
    if (status >= 400) {
      notificationType = "error";
    }
    data = action.payload.data;
  }

  let response = {
    notificationType: notificationType,
    type: action.type,
    status: status,
    action: "LIST",
  };
  switch (action.type) {
    case GET_CREDITS:
      response["data"] = data.credits;
      break;
    case GET_VOUCHERS:
      response["data"] = data.vouchers;
      break;
    case VOUCHER_RESPONSE_HANDLER:
      response["data"] = action.payload.data;
      response["action"] = "ACTION";
      break;
    case GET_CUSTOMER:
      response["data"] = action.payload.data;
      break;
      break;
    case FAILED_HANDLER:
      response["payload"] = action.payload;
      break;
    default:
      return state;
  }
  return response;
};
